/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientNotesModel } from '../../models/patient-notes-model';

export interface GetPatientNotes$Params {
  patientID?: number;
}

export function GetPatientNotes(http: HttpClient, rootUrl: string, params?: GetPatientNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientNotesModel>> {
  const rb = new RequestBuilder(rootUrl, GetPatientNotes.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PatientNotesModel>;
    })
  );
}

GetPatientNotes.PATH = '/api/Supervisor/GetPatientNotes';
